import { render, staticRenderFns } from "./SpeciesAndBreeds.vue?vue&type=template&id=02dc0a48"
import script from "./SpeciesAndBreeds.vue?vue&type=script&lang=js"
export * from "./SpeciesAndBreeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports